export default {
    meta: {
        title: '拓店宝-审批',
        url: '/decision',
        urlName: '审批' // 埋点字段，上报归属的模块
        // eventId: 'e0ab567e-67ac-428a-a632-45ab0d99df16'
    },
};
